(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/aboutus/aboutus.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/aboutus/aboutus.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"text-center\">\n    <h2>\n        Nestled in the heart of downtown Franklin since 1978,<br />\n        Shuff's Music & Piano Showroom is a full-line music store offering<br />\n        quality products at competitive prices.\n    </h2>\n    <mat-divider></mat-divider>\n    <table>\n        <tr>\n            <td width=\"30%\">\n                <img src=\"./assets/images/ShuffsPianoShowroom.gif\" class=\"img-responsive\">\n            </td>\n            <td width=\"70%\">\n                <p>\n                    Our Piano Showroom and warehouse are located at 127 Second Avenue North. The front building holds\n                    our\n                    beautiful Piano Showroom, which is stocked with new and used pianos. Piano lessons are taught in the\n                    back of\n                    the building.\n                </p>\n                <p>\n                    Located behind the Piano Showroom is our Used Piano Warehouse.\n                </p>\n                <p>\n                    We have many brands of acoustic and digital pianos to fit any budget, such as: Yamaha, Steinway,\n                    Kawai,\n                    Kohler & Campbell, Story & Clark, and many more! We are constantly getting pianos so check back\n                    frequently\n                    with us!\n                </p>\n                <p>\n                    Not looking to buy just yet? No problem! Ask us about our Piano Rentals.\n                </p>\n            </td>\n        </tr>\n    </table>\n    <mat-divider></mat-divider>\n    <table>\n        <tr>\n            <td width=\"30%\">\n                <img src=\"./assets/images/ShuffsMusicBlueBuilding.jpg\" class=\"img-responsive\">\n            </td>\n            <td width=\"70%\">\n                <p>\n                    Just one street over at 118 Third Avenue North is our Music Store. This building is our original\n                    location in\n                    the historical Gaut House from 1828. We stock a wide variety of band instruments, acoustic &\n                    electric\n                    guitars, ukuleles, banjos, other musical instruments, drums, sheet music, musical accessories, and\n                    so much\n                    more! We also provide rentals for band instruments and orchestra instruments.\n                </p>\n                <p>\n                    Our tops floors are dedicated to music lessons and group music classes. There are many comfortable\n                    areas for\n                    parents to relax while their child takes a music lesson with their music teacher. We offer music\n                    lessons for\n                    almost every instrument! Click here for more information on music lessons.\n                </p>\n            </td>\n        </tr>\n    </table>\n    <mat-divider></mat-divider>\n    <h2>Please stop in and say hello!</h2>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-sidenav-container class=\"main-container\">\n  <mat-sidenav mode=\"over\" #sidenav>\n    <mat-nav-list color=\"primary\">\n      <a mat-list-item [routerLink]=\"'/home'\" [routerLinkActive]=\"['list-item-is-active']\">Home</a>\n      <a mat-list-item [routerLink]=\"'/aboutus'\" [routerLinkActive]=\"['list-item-is-active']\">About Us</a>\n      <a mat-list-item [routerLink]=\"'/ourstaff'\" routerLinkActive=\"list-item-is-active\">Our Staff</a>\n      <a mat-list-item [routerLink]=\"'/services'\" routerLinkActive=\"list-item-is-active\">Services</a>\n      <a mat-list-item [routerLink]=\"'/products'\" routerLinkActive=\"list-item-is-active\">Products</a>\n      <a mat-list-item [routerLink]=\"'/rentals'\" routerLinkActive=\"list-item-is-active\">Rentals</a>\n      <a mat-list-item [routerLink]=\"'/musiclessons'\" routerLinkActive=\"list-item-is-active\">Music Lessons</a>\n      <a mat-list-item [routerLink]=\"'/contactus'\" routerLinkActive=\"list-item-is-active\">Contact Us</a>\n    </mat-nav-list>\n  </mat-sidenav>\n\n  <mat-sidenav-content>\n    <mat-toolbar color=\"primary\">\n      <mat-toolbar-row>\n        <button mat-button (click)=\"sidenav.toggle()\">\n          <mat-icon>menu</mat-icon>\n        </button>\n      </mat-toolbar-row>\n    </mat-toolbar>\n\n    <router-outlet></router-outlet>\n\n    <div class=\"headerlogo text-center\">\n        <mat-grid-list cols=\"2\" rowHeight=\"150px\">\n            <mat-grid-tile>\n                <div>\n                    <h3>Shuff's Piano Showroom</h3>\n                    127 2nd Avenue North<br />\n                    Historic Downtown Franklin, TN<br />\n                    <b>(615) 261-8888</b>\n                </div>\n            </mat-grid-tile>\n            <mat-grid-tile>\n                <div>\n                    <h3>Shuff's Music Store</h3>\n                    118 3rd Avenue North<br />\n                    Historic Downtown Franklin, TN<br />\n                    <b>(615) 790-6139</b>\n                </div>\n            </mat-grid-tile>\n        </mat-grid-list>\n    </div>\n    <mat-toolbar color=\"primary\">\n      <span>&nbsp;</span>\n      <span class=\"footer\">\n        <mat-nav-list color=\"primary\" class=\"footer\">\n          <a href=\"/returnpolicy\"> Return Policy </a>\n          <a href=\"/securitypolicy\"> Security Policy </a>\n          &copy; Shuff's Music. All Rights Reserved.\n        </mat-nav-list>\n      </span>\n      <span>&nbsp;</span>\n    </mat-toolbar>\n  </mat-sidenav-content>\n</mat-sidenav-container>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/contactus/contactus.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/contactus/contactus.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>contactus works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html":
/*!********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"headerlogo\">\n    <div class=\"header-bg\">\n        <mat-grid-list cols=\"2\" rowHeight=\"150px\">\n            <mat-grid-tile>\n                <img src=\"./assets/images/logo.jpg\" />\n            </mat-grid-tile>\n            <mat-grid-tile>\n                <div class=\"text-center\">\n                    <div>\n                        <a target=\"_blank\" href=\"https://www.facebook.com/ShuffsMusic\"><img alt=\"\"\n                                class=\"img-responsize\" src=\"./assets/images/facebook-icon.png\"></a>\n                        <a target=\"_blank\" href=\"https://plus.google.com/109524208825225308091/posts\"><img alt=\"\"\n                                class=\"img-responsize\" src=\"./assets/images/googleplus-icon.png\"></a>\n                        <a target=\"_blank\" href=\"https://twitter.com/Shuffs_Music\"><img alt=\"\" class=\"img-responsize\"\n                                src=\"./assets/images/twitter-icon.png\"></a>\n                        <a target=\"_blank\" href=\"https://instagram.com/shuffs_music/\"><img alt=\"\" class=\"img-responsize\"\n                                src=\"./assets/images/instgram-icon.png\"></a>\n                        <a target=\"_blank\" href=\"http://www.pinterest.com/shuffsmusic/\"><img alt=\"\"\n                                class=\"img-responsize\" src=\"./assets/images/pinterest-icon.png\"></a>\n                    </div>\n                    <br>\n                    <div>\n                        <span style=\"font-size: 16px;\">Music Store <strong>(615) 790-6139</strong> </span><br>\n                        <span style=\"font-size: 16px;\">Piano Showroom <strong>(615) 261-8888</strong></span>\n                    </div>\n                </div>\n            </mat-grid-tile>\n        </mat-grid-list>\n    </div>\n</div>\n\n<div class=\"text-center\">\n\n    <img class=\"img-responsive\" [src]=\"carouselImagePath\"><br />\n    <button mat-button (click)=\"getPreviousCarousel()\"><mat-icon>navigate_before</mat-icon></button>\n    <button mat-button (click)=\"getNextCarousel()\"><mat-icon>navigate_next</mat-icon></button>\n\n    <p>&nbsp;</p>\n    <p><strong style=\"font-size: large; font-family: Georgia; text-align: left;\"><span style=\"font-size: 48px;\">SHOP\n                SHUFF'S</span></strong></p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n    <p><span style=\"text-align: left; font-size: 26px; font-family: Georgia;\">For All Your Musical Needs</span></p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n    <p><strong style=\"font-size: large; font-family: Georgia; text-align: left;\"><span style=\"font-size: 28px;\">100%\n                Local For Over 40 Years</span></strong></p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n    <p><strong style=\"font-size: large; font-family: Georgia; text-align: left;\"><span\n                style=\"font-size: 36px;\">SALES&nbsp;• RENTALS&nbsp;• LESSONS</span></strong></p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n    <iframe width=\"427\" height=\"240\" src=\"https://www.youtube.com/embed/PZ_AZE8UG54\" frameborder=\"0\"\n        allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n</div>\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/musiclessons/musiclessons.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/musiclessons/musiclessons.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>musiclessons works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/ourstaff/ourstaff.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/ourstaff/ourstaff.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>ourstaff works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/products/products.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/products/products.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>products works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/rentals/rentals.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/rentals/rentals.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>rentals works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/returnpolicy/returnpolicy.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/returnpolicy/returnpolicy.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card class=\"card-full-height\">\n    <mat-card-title>\n        Return Policy\n    </mat-card-title>\n    <mat-card-content>\n        <p>\n            If you're not completely satisfied with a product purchased online, Shuff’s Music will gladly exchange or\n            refund\n            the\n            purchase within 14 days of the sale date, except as noted below. In order to receive full credit, returned\n            merchandise must be re-boxed in the original packaging and be in “new” condition along with the original\n            purchase\n            receipt, instruction manuals, packing, warranty cards, and accessories. Any damages, missing items, markings\n            on\n            the\n            original box for the product will result in a re-stocking fee of up to 20%.\n        </p>\n        <p>\n            PLEASE BE SURE NOT TO WRITE ON OR MARK THE ORIGINAL BOX FOR THE PRODUCT. ALL PRODUCTS SHOULD BE BOXED IN\n            ANOTHER\n            SHIPPING BOX FOR RETURN. Exceptions: Sheet Music, Books, Reeds, Strings, Harmonicas, Microphones,\n            media/software,\n            mouth blown products, repair parts, non-portable keyboard products, and recording devices are non\n            returnable.\n            Serialized merchandise may be subject to up to a 20% restocking fee. Special orders can only be returned at\n            the\n            discretion of a Store Manager with a restocking fee added. All deposits on special orders are\n            non-refundable.\n            <b>All\n                shipping costs are the responsibility of the customer and are non-refundable.</b>\n        </p>\n        <p>\n            Please direct all inquires to store manager at 615-790-6139 or click here to email us.\n        </p>\n    </mat-card-content>\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/securitypolicy/securitypolicy.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/securitypolicy/securitypolicy.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card class=\"card-full-height\">\n    <mat-card-title>\n        Security Policy\n    </mat-card-title>\n    <mat-card-content>\n        <h4>Overview</h4>\n        <p>\n            Shuff’s Music & Piano Showroom does not rent, trade, lend or sell your personal information, or any other\n            information which may identify you, to third parties. We are committed to protecting our customers' privacy.\n            The information we collect is used to process your order and to enhance your shopping experience. We also\n            monitor customer traffic patterns and site usage in order to help us refine the design and layout of the\n            store. For more detailed information on our privacy policy, please continue reading.\n        </p>\n        <h4>Your Personal Information</h4>\n        <p>\n            When you place an order at our site, you provide us with your name, email address, credit card information,\n            address, and phone number. We use this information to process your order and keep you up to date on its\n            status. The financial information (credit card number, expiration date, billing address, etc.) that we\n            collect from you is used for billing purposes only.\n        </p>\n        <h4>Secure Servers</h4>\n        <p>\n            Our secure server uses advanced encryption and firewall technology to keep your personal information\n            private. Our secure server layer (SSL) software encrypts the information you input so that it cannot be read\n            as it travels to our ordering system. We have strong security measures in place to protect against the loss,\n            misuse, or alteration of your information while it is in our control.\n        </p>\n        <h4>Cookies</h4>\n        <p>\n            \"Cookies\" are small pieces of information that are stored by the browser onto your computer's hard drive. We\n            use cookies to keep track of your current shopping session. Shuff’s Music & Piano Showroom does not use\n            cookies to store/retrieve your personal information. By default, most web browsers have both types of\n            cookies enabled, but these settings can be altered.\n        </p>\n        <h4>Your Consent</h4>\n        <p>\n            By using our web site, you are agreeing to let us collect the aforementioned information (please see the\n            above) and use it in the said manner. If we decide to change our privacy policy, we will post those changes\n            on this page. Shuff’s Music & Piano Showroom will cooperate with law enforcement agencies to identify any\n            individual who attempts to use our services for illegal activities. We will also report any activity we\n            believe to be unlawful, to the proper authorities. Additionally, we may release account information when we\n            feel that such a release is necessary to enforce the terms of our user agreement, or to protect the rights,\n            property, and safety of our users, Shuff’s Music & Piano Showroom, or others.\n        </p>\n    </mat-card-content>\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/services/services.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/services/services.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>services works!</p>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/aboutus/aboutus.component.less":
/*!************************************************!*\
  !*** ./src/app/aboutus/aboutus.component.less ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Fib3V0dXMvYWJvdXR1cy5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/aboutus/aboutus.component.ts":
/*!**********************************************!*\
  !*** ./src/app/aboutus/aboutus.component.ts ***!
  \**********************************************/
/*! exports provided: AboutusComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AboutusComponent", function() { return AboutusComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AboutusComponent = class AboutusComponent {
    constructor() { }
    ngOnInit() {
    }
};
AboutusComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-aboutus',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./aboutus.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/aboutus/aboutus.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./aboutus.component.less */ "./src/app/aboutus/aboutus.component.less")).default]
    })
], AboutusComponent);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./home/home.component */ "./src/app/home/home.component.ts");
/* harmony import */ var _aboutus_aboutus_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./aboutus/aboutus.component */ "./src/app/aboutus/aboutus.component.ts");
/* harmony import */ var _returnpolicy_returnpolicy_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./returnpolicy/returnpolicy.component */ "./src/app/returnpolicy/returnpolicy.component.ts");
/* harmony import */ var _securitypolicy_securitypolicy_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./securitypolicy/securitypolicy.component */ "./src/app/securitypolicy/securitypolicy.component.ts");







const routes = [
    { path: 'home', component: _home_home_component__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"] },
    { path: 'aboutus', component: _aboutus_aboutus_component__WEBPACK_IMPORTED_MODULE_4__["AboutusComponent"] },
    // {path: 'ourstaff', component: OurstaffComponent},
    // {path: 'services', component: ServicesComponent},
    // {path: 'products', component: ProductsComponent},
    // {path: 'rentals', component: RentalsComponent},
    // {path: 'musiclessons', component: MusiclessonsComponent},
    // {path: 'contactus', component: ContactusComponent},
    { path: 'returnpolicy', component: _returnpolicy_returnpolicy_component__WEBPACK_IMPORTED_MODULE_5__["ReturnpolicyComponent"] },
    { path: 'securitypolicy', component: _securitypolicy_securitypolicy_component__WEBPACK_IMPORTED_MODULE_6__["SecuritypolicyComponent"] },
    { path: '**', redirectTo: 'home' }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.less":
/*!************************************!*\
  !*** ./src/app/app.component.less ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.isNavVisible = false;
    }
    ngOnInit() {
    }
    toggleNav() {
        if (this.isNavVisible) {
            this.isNavVisible = false;
        }
        else {
            this.isNavVisible = true;
        }
    }
    closeNav() {
        this.isNavVisible = false;
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.less */ "./src/app/app.component.less")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./home/home.component */ "./src/app/home/home.component.ts");
/* harmony import */ var _aboutus_aboutus_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./aboutus/aboutus.component */ "./src/app/aboutus/aboutus.component.ts");
/* harmony import */ var _ourstaff_ourstaff_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ourstaff/ourstaff.component */ "./src/app/ourstaff/ourstaff.component.ts");
/* harmony import */ var _services_services_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./services/services.component */ "./src/app/services/services.component.ts");
/* harmony import */ var _products_products_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./products/products.component */ "./src/app/products/products.component.ts");
/* harmony import */ var _rentals_rentals_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./rentals/rentals.component */ "./src/app/rentals/rentals.component.ts");
/* harmony import */ var _musiclessons_musiclessons_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./musiclessons/musiclessons.component */ "./src/app/musiclessons/musiclessons.component.ts");
/* harmony import */ var _contactus_contactus_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./contactus/contactus.component */ "./src/app/contactus/contactus.component.ts");
/* harmony import */ var _returnpolicy_returnpolicy_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./returnpolicy/returnpolicy.component */ "./src/app/returnpolicy/returnpolicy.component.ts");
/* harmony import */ var _securitypolicy_securitypolicy_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./securitypolicy/securitypolicy.component */ "./src/app/securitypolicy/securitypolicy.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/divider */ "./node_modules/@angular/material/esm2015/divider.js");
/* harmony import */ var _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/material/grid-list */ "./node_modules/@angular/material/esm2015/grid-list.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_menu__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/material/menu */ "./node_modules/@angular/material/esm2015/menu.js");
/* harmony import */ var _angular_material_radio__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/radio */ "./node_modules/@angular/material/esm2015/radio.js");
/* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
/* harmony import */ var _angular_material_stepper__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/stepper */ "./node_modules/@angular/material/esm2015/stepper.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");



























let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _home_home_component__WEBPACK_IMPORTED_MODULE_5__["HomeComponent"],
            _aboutus_aboutus_component__WEBPACK_IMPORTED_MODULE_6__["AboutusComponent"],
            _ourstaff_ourstaff_component__WEBPACK_IMPORTED_MODULE_7__["OurstaffComponent"],
            _services_services_component__WEBPACK_IMPORTED_MODULE_8__["ServicesComponent"],
            _products_products_component__WEBPACK_IMPORTED_MODULE_9__["ProductsComponent"],
            _rentals_rentals_component__WEBPACK_IMPORTED_MODULE_10__["RentalsComponent"],
            _musiclessons_musiclessons_component__WEBPACK_IMPORTED_MODULE_11__["MusiclessonsComponent"],
            _contactus_contactus_component__WEBPACK_IMPORTED_MODULE_12__["ContactusComponent"],
            _returnpolicy_returnpolicy_component__WEBPACK_IMPORTED_MODULE_13__["ReturnpolicyComponent"],
            _securitypolicy_securitypolicy_component__WEBPACK_IMPORTED_MODULE_14__["SecuritypolicyComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_15__["BrowserAnimationsModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_16__["MatButtonModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_17__["MatCardModule"],
            _angular_material_divider__WEBPACK_IMPORTED_MODULE_18__["MatDividerModule"],
            _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_19__["MatGridListModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_20__["MatIconModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_21__["MatListModule"],
            _angular_material_menu__WEBPACK_IMPORTED_MODULE_22__["MatMenuModule"],
            _angular_material_radio__WEBPACK_IMPORTED_MODULE_23__["MatRadioModule"],
            _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_24__["MatSidenavModule"],
            _angular_material_stepper__WEBPACK_IMPORTED_MODULE_25__["MatStepperModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_26__["MatToolbarModule"]
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/contactus/contactus.component.less":
/*!****************************************************!*\
  !*** ./src/app/contactus/contactus.component.less ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbnRhY3R1cy9jb250YWN0dXMuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/contactus/contactus.component.ts":
/*!**************************************************!*\
  !*** ./src/app/contactus/contactus.component.ts ***!
  \**************************************************/
/*! exports provided: ContactusComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactusComponent", function() { return ContactusComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ContactusComponent = class ContactusComponent {
    constructor() { }
    ngOnInit() {
    }
};
ContactusComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-contactus',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./contactus.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/contactus/contactus.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./contactus.component.less */ "./src/app/contactus/contactus.component.less")).default]
    })
], ContactusComponent);



/***/ }),

/***/ "./src/app/home/home.component.less":
/*!******************************************!*\
  !*** ./src/app/home/home.component.less ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2hvbWUvaG9tZS5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/home/home.component.ts":
/*!****************************************!*\
  !*** ./src/app/home/home.component.ts ***!
  \****************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_components_models_carousel_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/components/models/carousel.model */ "./src/app/shared/components/models/carousel.model.ts");



let HomeComponent = class HomeComponent {
    constructor() {
        this.carouselImagePath = "./assets/uploads/carousel/carousel1.png";
        this.carouselImages = [];
        this.currentCarousel = null;
    }
    ngOnInit() {
        this.carouselImages.push(new _shared_components_models_carousel_model__WEBPACK_IMPORTED_MODULE_2__["Carousel"](1, "1", "", "", "png"));
        this.carouselImages.push(new _shared_components_models_carousel_model__WEBPACK_IMPORTED_MODULE_2__["Carousel"](2, "2", "", "", "png"));
        this.carouselImages.push(new _shared_components_models_carousel_model__WEBPACK_IMPORTED_MODULE_2__["Carousel"](3, "3", "", "", "png"));
        this.getNextCarousel();
        setInterval(() => {
            this.getNextCarousel();
        }, 3000);
    }
    getNextCarousel() {
        if (this.currentCarousel == null) {
            this.currentCarousel = this.carouselImages[0];
        }
        else {
            var currentIndex = this.carouselImages.indexOf(this.currentCarousel);
            if (currentIndex >= this.carouselImages.length - 1) {
                this.currentCarousel = this.carouselImages[0];
            }
            else {
                this.currentCarousel = this.carouselImages[currentIndex + 1];
            }
        }
        this.carouselImagePath = "./assets/uploads/carousel/carousel" + this.currentCarousel.Id + "." + this.currentCarousel.FileExt;
    }
    getPreviousCarousel() {
        if (this.currentCarousel == null) {
            this.currentCarousel = this.carouselImages[0];
        }
        else {
            var currentIndex = this.carouselImages.indexOf(this.currentCarousel);
            if (currentIndex <= 0) {
                this.currentCarousel = this.carouselImages[this.carouselImages.length - 1];
            }
            else {
                this.currentCarousel = this.carouselImages[currentIndex - 1];
            }
        }
        this.carouselImagePath = "./assets/uploads/carousel/carousel" + this.currentCarousel.Id + "." + this.currentCarousel.FileExt;
    }
};
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.less */ "./src/app/home/home.component.less")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/musiclessons/musiclessons.component.less":
/*!**********************************************************!*\
  !*** ./src/app/musiclessons/musiclessons.component.less ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL211c2ljbGVzc29ucy9tdXNpY2xlc3NvbnMuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/musiclessons/musiclessons.component.ts":
/*!********************************************************!*\
  !*** ./src/app/musiclessons/musiclessons.component.ts ***!
  \********************************************************/
/*! exports provided: MusiclessonsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MusiclessonsComponent", function() { return MusiclessonsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let MusiclessonsComponent = class MusiclessonsComponent {
    constructor() { }
    ngOnInit() {
    }
};
MusiclessonsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-musiclessons',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./musiclessons.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/musiclessons/musiclessons.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./musiclessons.component.less */ "./src/app/musiclessons/musiclessons.component.less")).default]
    })
], MusiclessonsComponent);



/***/ }),

/***/ "./src/app/ourstaff/ourstaff.component.less":
/*!**************************************************!*\
  !*** ./src/app/ourstaff/ourstaff.component.less ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL291cnN0YWZmL291cnN0YWZmLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/ourstaff/ourstaff.component.ts":
/*!************************************************!*\
  !*** ./src/app/ourstaff/ourstaff.component.ts ***!
  \************************************************/
/*! exports provided: OurstaffComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OurstaffComponent", function() { return OurstaffComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let OurstaffComponent = class OurstaffComponent {
    constructor() { }
    ngOnInit() {
    }
};
OurstaffComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-ourstaff',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./ourstaff.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/ourstaff/ourstaff.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./ourstaff.component.less */ "./src/app/ourstaff/ourstaff.component.less")).default]
    })
], OurstaffComponent);



/***/ }),

/***/ "./src/app/products/products.component.less":
/*!**************************************************!*\
  !*** ./src/app/products/products.component.less ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Byb2R1Y3RzL3Byb2R1Y3RzLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/products/products.component.ts":
/*!************************************************!*\
  !*** ./src/app/products/products.component.ts ***!
  \************************************************/
/*! exports provided: ProductsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProductsComponent", function() { return ProductsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ProductsComponent = class ProductsComponent {
    constructor() { }
    ngOnInit() {
    }
};
ProductsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-products',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./products.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/products/products.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./products.component.less */ "./src/app/products/products.component.less")).default]
    })
], ProductsComponent);



/***/ }),

/***/ "./src/app/rentals/rentals.component.less":
/*!************************************************!*\
  !*** ./src/app/rentals/rentals.component.less ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3JlbnRhbHMvcmVudGFscy5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/rentals/rentals.component.ts":
/*!**********************************************!*\
  !*** ./src/app/rentals/rentals.component.ts ***!
  \**********************************************/
/*! exports provided: RentalsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RentalsComponent", function() { return RentalsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let RentalsComponent = class RentalsComponent {
    constructor() { }
    ngOnInit() {
    }
};
RentalsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-rentals',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./rentals.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/rentals/rentals.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./rentals.component.less */ "./src/app/rentals/rentals.component.less")).default]
    })
], RentalsComponent);



/***/ }),

/***/ "./src/app/returnpolicy/returnpolicy.component.less":
/*!**********************************************************!*\
  !*** ./src/app/returnpolicy/returnpolicy.component.less ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3JldHVybnBvbGljeS9yZXR1cm5wb2xpY3kuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/returnpolicy/returnpolicy.component.ts":
/*!********************************************************!*\
  !*** ./src/app/returnpolicy/returnpolicy.component.ts ***!
  \********************************************************/
/*! exports provided: ReturnpolicyComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReturnpolicyComponent", function() { return ReturnpolicyComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ReturnpolicyComponent = class ReturnpolicyComponent {
    constructor() { }
    ngOnInit() {
    }
};
ReturnpolicyComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-returnpolicy',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./returnpolicy.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/returnpolicy/returnpolicy.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./returnpolicy.component.less */ "./src/app/returnpolicy/returnpolicy.component.less")).default]
    })
], ReturnpolicyComponent);



/***/ }),

/***/ "./src/app/securitypolicy/securitypolicy.component.less":
/*!**************************************************************!*\
  !*** ./src/app/securitypolicy/securitypolicy.component.less ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NlY3VyaXR5cG9saWN5L3NlY3VyaXR5cG9saWN5LmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/securitypolicy/securitypolicy.component.ts":
/*!************************************************************!*\
  !*** ./src/app/securitypolicy/securitypolicy.component.ts ***!
  \************************************************************/
/*! exports provided: SecuritypolicyComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecuritypolicyComponent", function() { return SecuritypolicyComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SecuritypolicyComponent = class SecuritypolicyComponent {
    constructor() { }
    ngOnInit() {
    }
};
SecuritypolicyComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-securitypolicy',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./securitypolicy.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/securitypolicy/securitypolicy.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./securitypolicy.component.less */ "./src/app/securitypolicy/securitypolicy.component.less")).default]
    })
], SecuritypolicyComponent);



/***/ }),

/***/ "./src/app/services/services.component.less":
/*!**************************************************!*\
  !*** ./src/app/services/services.component.less ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NlcnZpY2VzL3NlcnZpY2VzLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/services/services.component.ts":
/*!************************************************!*\
  !*** ./src/app/services/services.component.ts ***!
  \************************************************/
/*! exports provided: ServicesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServicesComponent", function() { return ServicesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ServicesComponent = class ServicesComponent {
    constructor() { }
    ngOnInit() {
    }
};
ServicesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-services',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./services.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/services/services.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./services.component.less */ "./src/app/services/services.component.less")).default]
    })
], ServicesComponent);



/***/ }),

/***/ "./src/app/shared/components/models/carousel.model.ts":
/*!************************************************************!*\
  !*** ./src/app/shared/components/models/carousel.model.ts ***!
  \************************************************************/
/*! exports provided: Carousel, CarouselAdapter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return Carousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselAdapter", function() { return CarouselAdapter; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


class Carousel {
    constructor(Id, Name, Url, Caption, FileExt) {
        this.Id = Id;
        this.Name = Name;
        this.Url = Url;
        this.Caption = Caption;
        this.FileExt = FileExt;
    }
}
let CarouselAdapter = class CarouselAdapter {
    static mapGet(obj) {
        return new Carousel(obj.id, obj.name, obj.url, obj.caption, obj.fileExt);
    }
    static mapSetNoId(obj) {
        return {
            Name: obj.Name,
            Url: obj.Url,
            Caption: obj.Caption,
            FileExt: obj.FileExt
        };
    }
    static mapSet(obj) {
        return {
            Id: obj.Id,
            Name: obj.Name,
            Url: obj.Url,
            Caption: obj.Caption,
            FileExt: obj.FileExt
        };
    }
};
CarouselAdapter = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], CarouselAdapter);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\sites\shuffsui\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map